import { Box, Container } from "@material-ui/core";

import { Quote } from "../../../../api/Quote/Quote";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { QuoteInfo } from "./QuoteInfo";
import { useStyles } from "../../quoteDetail.styles";

interface Props {
  quote: Quote;
}

export const QuoteInfoSection = ({ quote }: Props) => {
  const { isMoreThanMd, isMoreThanSm } = useBreakpoint();
  const classes = useStyles();

  return (
    <Box display={"grid"} className={classes.heroSection} mt={isMoreThanMd ? "82px" : isMoreThanSm ? "40px" : "20px"}>
      {isMoreThanMd && (
        <Box width={"100%"} height={"100%"} display={"flex"} alignItems={"center"}>
          <Box bgcolor={"#f7f7f7"} width="50%" height={"222px"} />
        </Box>
      )}
      <Container maxWidth={"lg"}>
        <QuoteInfo quote={quote} />
      </Container>
    </Box>
  );
};
